import requiredRule from 'v-form-builder/src/libraries/validations/required';

const requiredValue = (fieldValue: any): boolean => {
  if (fieldValue === undefined || fieldValue === null) return false;
  return requiredRule(fieldValue);
};

export default requiredValue;
